import { render, staticRenderFns } from "./ProcessedFiles.vue?vue&type=template&id=5b8fcd01&"
import script from "./ProcessedFiles.vue?vue&type=script&lang=js&"
export * from "./ProcessedFiles.vue?vue&type=script&lang=js&"
import style0 from "./ProcessedFiles.vue?vue&type=style&index=0&id=5b8fcd01&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports